// import logo from "./logo.svg";
// import "./App.css";

import SolveExpression from "./components/SolveExpression/SolveExpression";

function App() {
  return <SolveExpression />;
}

export default App;
